const TITLE_SEPARATOR = " • ";

type DocumentTitleProps = {
  /** Page-specific segments, most specific first. "Taktile" is appended. */
  segments: string[];
};

/**
 * React hoists `<title>` into `<head>`, so this can be rendered anywhere in the
 * tree. Only one may be mounted at a time: with several titles in the head the
 * browser picks one arbitrarily, so nested routes must leave the title to their
 * leaf.
 */
export const DocumentTitle: React.FC<DocumentTitleProps> = ({ segments }) => (
  <title>{[...segments, "Taktile"].join(TITLE_SEPARATOR)}</title>
);
